import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "field is-grouped" }
const _hoisted_4 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_change_password = _resolveComponent("change-password")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_field = _resolveComponent("b-field")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_modal, {
      modelValue: $data.isChangePasswordFormVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.isChangePasswordFormVisible) = $event)),
      "has-modal-card": "",
      "trap-focus": "",
      "destroy-on-hide": false,
      "aria-role": "dialog",
      "aria-label": "Example Modal",
      "close-button-aria-label": "Close",
      "aria-modal": ""
    }, {
      default: _withCtx((props) => [
        _createVNode(_component_change_password, {
          onClose: props.close
        }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_b_breadcrumb, {
      size: "is-large",
      separator: "has-succeeds-separator",
      "aria-label": "breadcrumbs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_breadcrumb_item, { active: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('global.settings')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('settings.title')), 1),
      _createVNode(_component_b_field, {
        grouped: "",
        position: "is-left",
        label: _ctx.$t('settings.name'),
        "label-position": $data.labelPosition
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_input, {
            expanded: "",
            modelValue: $data.form.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.form.firstName) = $event)),
            placeholder: _ctx.$t('settings.firstNamePlaceholder')
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_b_input, {
            expanded: "",
            modelValue: $data.form.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.form.lastName) = $event)),
            placeholder: _ctx.$t('settings.lastNamePlaceholder')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label", "label-position"]),
      _createVNode(_component_b_field, {
        label: _ctx.$t('settings.email'),
        "label-position": $data.labelPosition,
        class: "has-icons-left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_input, {
            type: "email",
            icon: "email",
            modelValue: $data.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.email) = $event)),
            placeholder: _ctx.$t('settings.emailPlaceholder')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label", "label-position"]),
      _createVNode(_component_b_field, {
        label: _ctx.$t('settings.language'),
        "label-position": $data.labelPosition
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_select, {
            modelValue: $data.form.language,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.form.language) = $event))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("option", { value: "en" }, "English", -1),
              _createElementVNode("option", { value: "de" }, "Deutsch", -1)
            ]))]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label", "label-position"]),
      _createVNode(_component_b_button, {
        type: "is-danger",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.isChangePasswordFormVisible = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('settings.changePassword')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_b_button, {
          type: "is-primary",
          onClick: $options.save
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 64))
}